(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["DSQ_customer-forms"] && !window.DesignMode) return;
  try {
    
//   document.addEventListener("DOMContentLoaded", () => {
//     const formSection = document.querySelector(".form_personal_fields");
//     const inputs = formSection.querySelectorAll("input");

//     console.log({inputs});

//     // Function to check validity of all inputs
//     function checkValidity() {
//         const allValid = Array.from(inputs).every(input => input.checkValidity());
//         if (allValid) {
//             formSection.classList.add("valid"); // Add class if all are valid
//         } else {
//             formSection.classList.add("invalid");
//             formSection.classList.remove("valid"); // Remove class if any are invalid
//         }
//     }

    
//     // Attach event listeners to trigger checkValidity
//     inputs.forEach(input => {
//       console.log("Adding event listener to:", input);
//         input.addEventListener("input", checkValidity); // Trigger on input change
//     });
// });


  } catch(e) { console.error(e); }
})();
})();
